import React from 'react';
import { components } from 'react-select';

import { SelectOptionProps } from '../../SelectOption.types';
import { ControlProps } from './Control.types';
import { useStyles } from './Control.styles';

export const Control = ({ children, ...rest }: ControlProps) => {
  const { menuIsOpen } = rest;
  const { error, isDisabled } = rest.selectProps as unknown as SelectOptionProps;

  const styles = useStyles({
    isDisabled: Boolean(isDisabled),
    error,
    menuPlacement: rest.selectProps.menuPlacement,
    menuIsOpen,
  });

  const innerProps = {
    ...rest.innerProps,
    'data-testid': 'select_option__control',
  } as React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

  return (
    <components.Control css={styles.root} {...rest} innerProps={innerProps}>
      {children}
    </components.Control>
  );
};
